<div *ngIf="isBlockedPage" class="atp-preloader-container atp-preloader-container_auth"
  [class.atp-preloader-container_transparent]="!isPreloaderShow">
  <mat-spinner *ngIf="isPreloaderShow"></mat-spinner>
</div>

<form class="atp-actions-popup__container atp-actions-popup__container_auth" [formGroup]="form" (ngSubmit)="submit()" novalidate>

  <atp-title class="atp-actions-popup__title" text="Авторизация"></atp-title>

  <div mat-dialog-content class="atp-actions-popup__content">
    <mat-form-field class="form-field_full-width">
      <input type="email" matInput placeholder="Email" name="login" formControlName="login">
      <mat-icon matSuffix>person</mat-icon>
      <mat-error *ngIf="loginErrorLabel">{{loginErrorLabel}}</mat-error>
    </mat-form-field>
    <br>

    <mat-form-field class="form-field_full-width">
      <input matInput type="password" placeholder="Пароль" name="password" formControlName="password">
      <mat-icon matSuffix>security</mat-icon>
      <mat-error *ngIf="passwordErrorLabel">{{passwordErrorLabel}}</mat-error>
    </mat-form-field>
    <br>

    <a *ngIf="dialogRef; else isPopupElseBlock" mat-button class="auth__recovery-password-link"
      [queryParams]="{email: form.controls.login.value}" routerLink="/passwordrecovery" (click)="cancel()"
      color="primary">Восстановить пароль</a>
    <ng-template #isPopupElseBlock>
      <a mat-button class="auth__recovery-password-link" routerLink="/passwordrecovery"
        [queryParams]="{email: form.controls.login.value}" color="primary">Восстановить пароль</a>
    </ng-template>

  </div>

  <div mat-dialog-actions class="atp-actions-popup__actions"
    [class.atp-actions-popup__actions_auth-flex-start]="!dialogRef">
    <button mat-raised-button color="primary" type="submit" (click)="submit()">Вход</button>
    <button *ngIf="dialogRef" mat-raised-button color="warn" (click)="cancel()" type="button">Отмена</button>
  </div>

</form>